// import React, { useState } from "react";
// import ReactApexChart from "react-apexcharts";

// const CustomChart = () => {
//   const [chartData, setChartData] = useState({
//     series: [
//       {
//         data: [20, 40, 68, 80, 100, 10, 20, 40, 6, 30, 45, 50],
//         color: "#88BD42", // Custom color for bars
//       },
//     ],
//     options: {
//       chart: {
//         type: "bar",
//         toolbar: {
//           show: false,
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       xaxis: {
//         categories: [
//           "Jan",
//           "Feb",
//           "Mar",
//           "Apr",
//           "May",
//           "Jun",
//           "Jul",
//           "Aug",
//           "Sep",
//           "Oct",
//           "Nov",
//           "Dec",
//         ],
//         labels: {
//           formatter: function (value) {
//             return value;
//           },
//         },
//       },
//       tooltip: {
//         x: {
//           format: "dd/MM/yy HH:mm",
//         },
//       },
//       plotOptions: {
//         bar: {
//           horizontal: false, // Set to true for horizontal bars
//           columnWidth: "50%", // Control the width of the bars
//           endingShape: "flat", // Flat bar ends
//           borderRadius: 8, // Set border radius for rounded corners
//           colors: {
//             backgroundBarColors: ["#DEDFE1"],
//             backgroundBarOpacity: 0.9, // Background color opacity
//             backgroundBarRadius: 5, // Background color radius (optional)
//           },
//         },
//       },
//     },
//   });

//   return (
//     <div>
//       <div id="chart">
//         <ReactApexChart
//           options={chartData.options}
//           series={chartData.series}
//           type="bar" // Keep this as "bar"
//           height={500}
//         />
//       </div>
//       <div id="html-dist"></div>
//     </div>
//   );
// };

// export default CustomChart;

import ReactApexChart from "react-apexcharts";

const CustomChart = ({
  viewMode,
  weeklyGraphData,
  monthlyGraphData,
  yearlyGraphData,
}) => {
  const weeklyData = weeklyGraphData.map((item) => item.count);
  const weeklyCategories = weeklyGraphData.map((item) => item.label);

  const monthlyData = monthlyGraphData.map((item) => item.count);
  const monthlyCategories = monthlyGraphData.map((item) => item.label);

  const yearlyData = yearlyGraphData.map((item) => item.count);
  const yearlyCategories = yearlyGraphData.map((item) => item.label);

  const getChartData = () => {
    let data = [];
    let categories = [];

    if (viewMode === "weekly") {
      data = weeklyData;
      categories = weeklyCategories;
    } else if (viewMode === "monthly") {
      data = monthlyData;
      categories = monthlyCategories;
    } else if (viewMode === "yearly") {
      data = yearlyData;
      categories = yearlyCategories;
    }

    return {
      series: [
        {
          data,
          color: "#88BD42",
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories,
        },
        tooltip: {
          y: {
            formatter: (val) => val,
            title: { formatter: () => "" },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
            endingShape: "flat",
            borderRadius: 8,
            colors: {
              backgroundBarColors: ["#DEDFE1"],
              backgroundBarOpacity: 0.9,
              backgroundBarRadius: 5,
            },
          },
        },
      },
    };
  };

  const chartData = getChartData();

  return (
    <div>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={500}
      />
    </div>
  );
};

export default CustomChart;
